module.exports = __webpack_public_path__ + "assets/img/enterIcon1.ad9ea3b2.png";